import { BooleanParam, NumberParam, StringParam } from 'use-query-params';

import { SlideAnnotationEditType } from 'components/Procedure/Header/SlideInteractionMenu/SlideAnnotationTools/options';
import { ResultReviewIntent, resultReviewIntentParam } from 'components/Procedure/resultReviewIntent';
import { ResultType } from 'interfaces/experimentResults';
import { getActiveAnnotationAssignmentIdViewerKey } from 'services/annotations/useAnnotationQueryParams';
import { CompressedJsonParam } from 'utils/customQueryParamsConfigs';

export const ANALYSIS_AREAS_EXPLORE_PARAM = 'analysisAreasExplore';
export const ANALYSIS_AREAS_TSM_OPACITY = 30;
export const ANALYSIS_AREAS_REVIEW_TAB = 'annotations';

export const analysisAreasTissueReviewIntent = (): ResultReviewIntent => ({
  version: 1,
  selector: {
    resultTypes: [ResultType.SlideInferenceTsm],
  },
  selection: 'latest_per_slide',
  view: 'overlays',
  activate: 'all',
  opacity: ANALYSIS_AREAS_TSM_OPACITY,
});

export const analysisAreasExploreQuery = (annotationAssignmentId: number) => {
  const assignmentKey = getActiveAnnotationAssignmentIdViewerKey(0);
  return {
    [ANALYSIS_AREAS_EXPLORE_PARAM]: true,
    reviewTab: ANALYSIS_AREAS_REVIEW_TAB,
    editAnnotationsMode: SlideAnnotationEditType.Polygon,
    'slideInfobarTab-0': 'overlays',
    [resultReviewIntentParam]: analysisAreasTissueReviewIntent(),
    [assignmentKey]: annotationAssignmentId,
  };
};

export const analysisAreasExploreQuerySchema = {
  [ANALYSIS_AREAS_EXPLORE_PARAM]: BooleanParam,
  reviewTab: StringParam,
  editAnnotationsMode: StringParam,
  'slideInfobarTab-0': StringParam,
  [resultReviewIntentParam]: CompressedJsonParam,
  [getActiveAnnotationAssignmentIdViewerKey(0)]: NumberParam,
};
